import { usePageCapabilities } from '../../Shared/usePageCapabilities';
import { useGroupState } from './GroupContext';

export function useGroupCapabilities() {
  const state = useGroupState();

  const capabilities = {
    canAccessSettings: !!state?.group?.authenticatedUserIsOwner || !!state?.group?.authenticatedUserIsAdmin,
    canManageInvitations: !!state?.group?.canManageInvitations,
    canManageJobProspects: !!state?.group?.canManageJobProspects,
  };

  usePageCapabilities(capabilities, []);
}
